import { useMutation, useQueryClient } from '@tanstack/react-query';
import { uploadActivityFile, createManualActivity, type ManualActivityRequest } from '@/lib/api';
import { invalidateCalendarQueries } from './calendarQueryInvalidation';

export function useUploadActivityFile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => uploadActivityFile(file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['activities'] });
      invalidateCalendarQueries(queryClient);
    },
  });
}

export function useCreateManualActivity() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ManualActivityRequest) => createManualActivity(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['activities'] });
      invalidateCalendarQueries(queryClient);
    },
  });
}
